import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { fromEvent, merge, Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Component({
  selector: 'h3-button-with-popover',
  templateUrl: './button-with-popover.component.html',
  styleUrls: ['./button-with-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ButtonWithPopoverComponent
  extends DirectiveSuperclass
  implements OnInit
{
  @Input({ required: true }) popoverTitle!: string;
  @Input() tooltipText?: string;

  @ViewChild('trigger', { read: ElementRef, static: true })
  private trigger!: ElementRef;
  @ViewChild(CdkConnectedOverlay, { static: true })
  private popover!: CdkConnectedOverlay;

  isPopoverOpen$!: Observable<boolean>;

  ngOnInit() {
    this.isPopoverOpen$ = merge(
      fromEvent(this.trigger.nativeElement, 'click'),
      this.popover.overlayOutsideClick,
    ).pipe(
      debounceTime(0),
      map(() => !this.popover.open),
    );
  }
}
